import { PagedSearch } from '../../shared/model/paged-search.model';
import { ApiService } from 'src/app/shared';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class CertificationTypeService {
  public constructor(private _apiService: ApiService) {}

  public areCertificationsEnabled() {
    return this._apiService.get('Certifications/Enabled');
  }

  public getAllCertificationTypes() {
    const search = new PagedSearch();
    search.PageSize = 1000;

    return this._apiService.getPaged('Certifications/Types', search);
  }
}
